/* @flow */
import React from 'react';
import classnames from 'classnames';

// Style
import styles from './styles.scss';

// Components
import QuickViewIcon from 'dibs-vg/dist/react/info-circle';

type QuickViewButtonProps = {|
    openQuickView: () => void,
    showQuickViewIcon: boolean,
    hideDivider?: boolean,
    isTestVariant?: boolean,
|};

export function QuickViewButton({
    openQuickView,
    showQuickViewIcon,
    hideDivider,
    isTestVariant,
}: QuickViewButtonProps) {
    if (!showQuickViewIcon) {
        return null;
    }
    return (
        <a
            className={classnames(styles.link, {
                [styles.hideDivider]: hideDivider,
                [styles.isTestVariant]: isTestVariant,
            })}
            onClick={openQuickView}
        >
            <QuickViewIcon className={classnames({ [styles.isTestVariant]: isTestVariant })} />
        </a>
    );
}

// ignore default prop functions from coverage stats
/* istanbul ignore next */
QuickViewButton.defaultProps = {
    openQuickView: () => {},
    showQuickViewIcon: true,
};
